import { Lang } from 'Roblox';
import angular from 'angular';

let catalog = angular
    .module("catalog", ["robloxApp", "cursorPagination"])
        .config(["$locationProvider", "languageResourceProvider",
            function ($locationProvider, languageResourceProvider) {
                $locationProvider.html5Mode({
                    enabled: true,
                    requireBase: false
                });

                languageResourceProvider.setLanguageKeysFromFile(Lang.CatalogResources);
            }
        ]);

export default catalog;